import Vue from 'vue'

import Vuex from 'vuex'

import {applianceSummary} from '@/types/applianceSummary'
import { states } from '@/utils/states'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({

    strict: true,

    state: {

        isSkipAutoRedirectToRenewal: false,

        user: {

            email: null as string | null,

            role: null as string | null

        },

        showCookieBanner: false,

        isInitialWorkflow: false,

        isEdit: false,

        dialogTitle: '',

        fileAttachmentErrors: [] as string[],

        typeOfDevice: '',

        registrationQuestionnaireDateSubmitted: '',

        applianceSummary: null as applianceSummary | null,

        soleSourceOfHeatStatement: {

            id: null as number | null,

            addressId: null as number | null,

            declarantName: '',

            declarantCity: '',

            applianceAddress: '',

            applianceCity: '',

            signature: '',

            signatureDate: ''

        },

        manufacturedFirelogsStatement: {

            id: null as number | null,

            addressId: null as number | null,

            declarantName: '',

            declarantCity: '',

            applianceAddress: '',

            applianceCity: '',

            signature: '',

            signatureDate: ''

        },

        declaration: {

            declarantName: '',

            declarantAddress: '',

            applianceAddress: '',

            applianceCity: '',

            signatureDate: '',

            expirationDate: ''

        },

        userProfile: {

            email: null as string | null,

            firstName: null as string | null,

            lastName: null as string | null,

            addressLine1: null as string | null,

            addressLine2: null as string | null,

            country: null as string | null,

            city: null as string | null,

            postalCode: null as string | null,

            province: null as string | null,

            phoneCode: null as string | null,

            phone: null as string | null,

            alternateEmail: null as string | null

        },

        address: {

            id: null as number | null,

            userId: null as number | null,

            addressLine1: null as string | null,

            unit: null as string | null,

            city: null as string | null,

            postalCode: null as string | null,

            province: null as string | null,

            isInUCB: false

        },

        fullAddress: '',

        appliance: {

            id: null as number | null,

            manufacturer: '',

            model: '',

            typeOfDevice: '',

            emissionRate: '',

            year: '',

            fileAttachment1: null as any,

            fileAttachment1Filename: '',

            fileAttachment2: null as any,

            fileAttachment2Filename: '',

            fileAttachment3: null as any,

            fileAttachment3Filename: '',

            isManual: false

        }

    },

    mutations: {

        UPDATE_IS_SKIP_AUTO_REDIRECT_TO_RENEWAL(state, payload) {

            state.isSkipAutoRedirectToRenewal = payload

        },

        UPDATE_SHOW_COOKIE_BANNER(state, payload) {

            state.showCookieBanner = payload

        },

        UPDATE_APPLIANCE_SUMMARY(state, payload) {

            state.applianceSummary = payload

        },

        UPDATE_REGISTRATION_QUESTIONNAIRE_DATE_SUBMITTED(state, payload) {

            state.registrationQuestionnaireDateSubmitted = payload

        },

        UPDATE_DECLARATION(state, payload) {

            state.declaration = payload

        },

        UPDATE_IS_INITIAL_WORKFLOW(state, payload) {

            state.isInitialWorkflow = payload

        },

        UPDATE_IS_EDIT(state, payload) {

            state.isEdit = payload

        },

        UPDATE_DIALOG_TITLE(state, payload) {

            state.dialogTitle = payload

        },

        UPDATE_FILE_ATTACHMENT_ERRORS(state, payload) {

            state.fileAttachmentErrors = payload

        },

        UPDATE_USERPROFILE(state, payload) {

            state.userProfile = payload

        },

        UPDATE_USER(state, payload) {

            state.user = payload

        },

        UPDATE_ADDRESS(state, payload) {

            state.address = payload

        },

        UPDATE_FULL_ADDRESS(state, payload) {

            state.fullAddress = payload

        },

        UPDATE_ADDRESS_ID(state, payload) {

            state.address.id = payload

        },

        UPDATE_SOLE_SOURCE_OF_HEAT_STATEMENT_ID(state, payload) {

            state.soleSourceOfHeatStatement.id = payload

        },

        UPDATE_MANUFACTURED_FIRELOGS_ID(state, payload) {

            state.manufacturedFirelogsStatement.id = payload

        },

        UPDATE_APPLIANCE_ID(state, payload) {

            state.appliance.id = payload

        },

        UPDATE_TYPE_OF_DEVICE(state, payload) {

            state.typeOfDevice = payload

        }

    },

    actions: {
        async getUser({ commit }) {
            try {
                // check authorization and update role, if necessary
                const resp = await axios.get('accounts/getUser')
                commit('UPDATE_USER', resp.data)

                return new Promise<any>((resolve) => {
                    resolve(resp)
                })
            } catch (error) {
                // assume not autenticated
                commit('UPDATE_USER', null)
            }
        },
        retrieveUser({ commit, dispatch }) {
            if (window.localStorage.getItem('user')) {
                const user = JSON.parse(window.localStorage.getItem('user') as string)
                commit('UPDATE_USER', user)
            }
            dispatch('getUser')
        },
        storeUserToLocalStorage({ state }) {
            window.localStorage.setItem('user', JSON.stringify(state.user))
        },
        async updateIsSkipAutoRedirectToRenewal({commit}, payload){

            commit('UPDATE_IS_SKIP_AUTO_REDIRECT_TO_RENEWAL', payload)

        },

        async updateShowCookieBanner({commit}, payload){

            commit('UPDATE_SHOW_COOKIE_BANNER', payload)

        },

        async updateApplianceSummary({commit}, payload){

            commit('UPDATE_APPLIANCE_SUMMARY', payload)

        },

        async updateRegistrationQuestionnaireDateSubmitted({commit}, payload){

            commit('UPDATE_REGISTRATION_QUESTIONNAIRE_DATE_SUBMITTED', payload)

        },

        async updateDeclaration({commit}, payload){

            commit('UPDATE_DECLARATION', payload)

        },

        async updateIsInitialWorkflow({commit}, payload){

            commit('UPDATE_IS_INITIAL_WORKFLOW', payload)

        },

        async updateIsEdit({commit}, payload){

            commit('UPDATE_IS_EDIT', payload)

        },

        async updateDialogMode({commit}, payload){

            commit('UPDATE_DIALOG_MODE', payload)

        },

        async updateDialogTitle({commit}, payload){

            commit('UPDATE_DIALOG_TITLE', payload)

        },

        async updateWorkflowMode({commit}, payload){

            commit('UPDATE_WORKFLOW_MODE', payload)

        },

        async updateFileAttachmentErrors({commit}, payload){

            commit('UPDATE_FILE_ATTACHMENT_ERRORS', payload)

        },

        async updateUserProfile({commit}, payload){

            commit('UPDATE_USERPROFILE', payload)

        },

        async updateUser({commit, dispatch}, payload){
            commit('UPDATE_USER', payload)
            dispatch('storeUserToLocalStorage')
        },

        async updateAddress({commit}, payload){

            commit('UPDATE_ADDRESS', payload)

        },

        async updateFullAddress({commit}, payload){

            commit('UPDATE_FULL_ADDRESS', payload)

        },

        async updateAddressId({commit}, payload){

            commit('UPDATE_ADDRESS_ID', payload)

        },

        async updateSoleSourceOfHeatStatementId({commit}, payload){

            commit('UPDATE_SOLE_SOURCE_OF_HEAT_STATEMENT_ID', payload)

        },

        async updateApplianceTypeOfDevice({commit}, payload){

            commit('UPDATE_APPLIANCE_TYPE_OF_DEVICE', payload)

        },

        async updateApplianceId({commit}, payload){

            commit('UPDATE_APPLIANCE_ID', payload)

        },

        async updateTypeOfDevice({commit}, payload){

            commit('UPDATE_TYPE_OF_DEVICE', payload)

        }

    },
    getters: {
        isAdmin: state => (state.user?.role ?? '') === 'Admin',
        isUser: state => (state.user?.role ?? '') === 'User'
    }
})
